export const convertUriImg = (x) => {
    return require("../assets/images/" + x);
}

export const convertUriIcon = (x) => {
    return require("../assets/Icons/" + x);
}

export const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
}